.track {
  width: 100%;
  height: 8px;
  overflow: hidden;
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-bg-subtle);
}
.value {
  height: 100%;
  border-radius: var(--hs-radius-full);
  transition: width 200ms ease;
}
.olive {
  background: var(--hs-color-secondary-default);
}
.lavender {
  background: var(--hs-color-primary-default);
}
.soft {
  background: var(--hs-color-secondary-soft);
}

.meter {
  display: flex;
  flex-direction: column;
  gap: var(--hs-spacing-2);
}
.row {
  display: flex;
  justify-content: space-between;
  gap: var(--hs-spacing-3);
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
}
.name {
  color: var(--hs-color-text-primary);
}
.number {
  font-variant-numeric: tabular-nums;
}
.oliveText {
  color: var(--hs-color-secondary-default);
}
.lavenderText {
  color: var(--hs-color-primary-default);
}
.softText {
  color: var(--hs-color-secondary-hover);
}
